import { ToastData, ToastPosition } from '../toasts.store';

export type GroupedToasts = Record<ToastPosition, ToastData[]>;

export const TOAST_POSITIONS: ToastPosition[] = [
    'bottom-center',
    'bottom-start',
    'bottom-end',
    'top-center',
    'top-start',
    'top-end',
];

export function getGroupedToasts(toasts: ToastData[], defaultPosition: ToastPosition) {
    return toasts.reduce<GroupedToasts>(
        (acc, toast) => {
            acc[toast.position || defaultPosition].push(toast);
            return acc;
        },
        TOAST_POSITIONS.reduce<GroupedToasts>((acc, item) => {
            acc[item] = [];
            return acc;
        }, {} as GroupedToasts)
    );
}
